
import React, { useMemo, useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import apiUrl from "../../environment/Api";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import styled from "styled-components";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from "react-table";
import { createPortal } from "react-dom";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import ActionsDropdown from "../ActionsDropdown";

const TableContainer = styled.div`
  padding: 20px;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;

  // Apply striped rows styling
  tr:nth-child(even) {
    background-color: #ffffff; /* Light gray for even rows */
  }

  tr:nth-child(odd) {
    background-color: #f2f2f2; /* White for odd rows */
  }
`;

const Th = styled.th`
  padding: 10px;
  background-color: #ffffff;
  text-align: left;
  cursor: pointer;
  position: relative;
`;

const Td = styled.td`
  padding: 10px;
  // border: 1px solid #ddd;
`;

function GlobalFilter({ globalFilter, setGlobalFilter }) {
  return (
    <div style={{ marginBottom: "10px" }}>
      <input
        value={globalFilter || ""}
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Search all columns..."
        style={{
          padding: "5px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          width: "100%",
        }}
      />
    </div>
  );
}
// Default Column Filter (Icon-based)
const DefaultColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const [isActive, setIsActive] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const options = useMemo(() => {
    const uniqueValues = Array.from(
      new Set(preFilteredRows.map((row) => row.values[id]))
    ).map((value) => ({ label: value, value }));
    return [{ label: "All", value: "" }, ...uniqueValues];
  }, [id, preFilteredRows]);

  // Handle icon click
  const handleIconClick = () => {
    setIsActive(!isActive);
  };

  const handleMultiSelectChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilter(values.length > 0 ? values : undefined);
  };

  return (
    <div style={{ alignItems: "center" }}>
      <div>
        <i
          className="fa-solid fa-ellipsis-vertical"
          onClick={handleIconClick}
          style={{
            cursor: "pointer",
            fontSize: "20px",
            color: "#AC0000",
          }}
        ></i>
      </div>
      <div>
        {isActive &&
          createPortal(
            <div
              style={{
                position: "fixed",
                zIndex: 9999,
                left: "50%",
                top: "50%",
                width: "30%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div
                style={{
                  position: "relative",
                  background: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  backgroundColor: "#A70000",
                }}
              >
                <Select
                  options={options}
                  isMulti
                  value={options.filter((option) =>
                    filterValue?.includes(option.value)
                  )}
                  onChange={handleMultiSelectChange}
                  isClearable
                  isSearchable
                  placeholder={`Filter ${id}`}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),
                  }}
                />
                <button
                  style={{
                    marginTop: "10px",
                    marginLeft: "150px",
                    padding: "5px 10px",
                    background: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsActive(false)} // Close the popup
                >
                  Close
                </button>
              </div>
            </div>,
            document.body
          )}
      </div>
    </div>
  );
};

function Travel_Allowance() {
  const [responseData, setResponseData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [role_id, setroleid] = useState("");
  const [previllages, setprevillages] = useState({});
  const [branch, setbranch] = useState([]);
  const [rolename, setrolename] = useState([]);
  const [staffId, Setstaffid] = useState([]);

  const data = useMemo(() => {
    return responseData.map((item) => ({
      _id: item._id,
      name: item.name,

      Staff_name: item.Staff_name,
      date: item.date,
      allowance_type: item.allowance_type,
      transport_mode: item.transport_mode,
      from: item.from,
      to: item.to,
      distance: item.distance,
      ticket_bill: item.ticket_bill,
      amount: item.amount,
      status: item.status,
      food_bill: item.food_bill,
      food_location: item.food_location,
      remarks: item.remarks,
      stay_bill: item.stay_bill,
      stay_location: item.stay_location,
      branch_id: {
        _id: item.branch_id?._id ?? null,
        branch_name: item.branch_id?.branch_name ?? "",
      },
    }));
  }, [responseData]);

  useEffect(() => {
    const branchName = localStorage.getItem("branch_name");
    setrolename(branchName);
  }, []);

  const columns = useMemo(
    () => {
      const baseColumns = [
        {
          Header: "S.No",
          id: "serialNo",
          Cell: ({ row }) => {
            return row.index + 1;
          },
        },

        {
          Header: "Name",
          accessor: "name",
          Filter: DefaultColumnFilter,
          filter: "multiSelectFilter",
        },
        {
          Header: "Staff Name",
          accessor: "Staff_name",
          Filter: DefaultColumnFilter,
          filter: "multiSelectFilter",
        },

        // {
        //   Header: "Date",
        //   accessor: "date",
        //   Filter: DefaultColumnFilter,
        //   filter: "multiSelectFilter",
        // },

        {
          Header: "Date",
          accessor: "date",
          Filter: DefaultColumnFilter,
          filter: "multiSelectFilter",
          Cell: ({ value }) => {
            const date = new Date(value);  // Convert the ISO string to a Date object
            const day = String(date.getDate()).padStart(2, '0');  // Add leading zero if necessary
            const month = String(date.getMonth() + 1).padStart(2, '0');  // Get the month (zero-indexed, so add 1)
            const year = date.getFullYear();

            return `${day}-${month}-${year}`;  // Return the formatted date
          }
        },

        {
          Header: "Type",
          accessor: "allowance_type",
          Filter: DefaultColumnFilter,
          filter: "multiSelectFilter",
        },
        {
          Header: "Amount",
          accessor: "amount",
          Filter: DefaultColumnFilter,
          filter: "multiSelectFilter",
        },

        {
          Header: "Status",
          accessor: "status",
          Filter: DefaultColumnFilter,
          filter: "multiSelectFilter",
          Cell: ({ value }) => {
            // Apply conditional classes based on status
            const statusClass =
              value === "Approved"
                ? "text-white text-center green-label"
                : value === "Applied"
                  ? "text-white text-center red-label"
                  : value === "Verfied"
                    ? "text-white text-center red-label"
                    : "text-white text-center yellow-label"; // Default if no match

            return (
              <td>
                <p className={statusClass}>{value}</p>
              </td>
            );
          },
        },
      ];

      // Conditionally insert the Branch Name column after Serial No if role is Branches
      // if (rolename === "Branches") {
      //   baseColumns.splice(1, 0, {
      //     Header: "Branch",
      //     accessor: "branch_id.branch_name",
      //     Cell: ({ value }) => {
      //       // If value is an array, check the first element, otherwise handle it as an object
      //       if (Array.isArray(value)) {
      //         if (!value[0]) return "-"; // If array is empty, return "-"
      //         return value[0].branch_name || "--"; // Access the branch_name of the first item
      //       } else if (value && value.branch_name) {
      //         // If value is an object, directly return the branch_name
      //         return value.branch_name || "--";
      //       }
      //       return "-"; // Return "-" if value is neither an array nor an object with branch_name
      //     },
      //     Filter: DefaultColumnFilter,
      //     filter: "multiSelectFilter",
      //   });
      // }
      if (rolename === "Branches") {
        baseColumns.splice(1, 0, {
          Header: "Branch",
          accessor: "branch_id.branch_name",
          Cell: ({ value }) => {
            return value ? value : "-"; // Directly return the branch name or "-"
          },
          Filter: DefaultColumnFilter,
          filter: "multiSelectFilter",
        });
      }

      return baseColumns;
    },
    [rolename] // Add rolename as a dependency
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
    setPageSize,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 10 },
      defaultColumn: { Filter: DefaultColumnFilter },
      filterTypes: {
        multiSelectFilter: (rows, columnIds, filterValue) => {
          if (!filterValue || filterValue.length === 0) {
            return rows;
          }
          return rows.filter((row) => {
            const rowValue = row.values[columnIds[0]];
            const rowValueStr = String(rowValue);
            return filterValue.some((filterVal) =>
              rowValueStr.includes(String(filterVal))
            );
          });
        },
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const [addData, setAddData] = useState({
    branch_id: "",
    // idlocal: "",
    name: '',
    Staff_name: '',
    from: "",
    to: "",
    travel_distance: "",
    visitor_staff: "",
    date: "",
    allowance_type: "",
    transport_mode: "",
    distance: "",
    ticket_bill: "",
    amount: "",
    status: "",
    food_location: "",
    food_bill: "",
    stay_location: "",
    stay_bill: "",
    remarks: "",
    food_amount: "",
  });

  const [updateData, setUpdateData] = useState({
    branch_id: "",
    name: "",

    Staff_name: "",
    from: "",
    to: "",
    travel_distance: "",
    visitor_staff: "",
    date: "",
    allowance_type: "",
    transport_mode: "",
    distance: "",
    ticket_bill: "",
    amount: "",
    status: "",
    food_location: "",
    food_bill: "",
    stay_location: "",
    stay_bill: "",
    remarks: "",
    food_amount: "",
  });

  useEffect(() => {
    fetchData();
    getprevillages();
    gettoken();
    fetchDataed();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // const fetchDataed = async () => {
  //   try {
  //     const response = await axios.get(apiUrl + "/Branch");
  //     console.log("Response from server:", response.data);
  //     setbranch(response.data);
  //   } catch (error) {
  //     console.error("Error fetching data:", error.message);
  //   }
  // };



  // const fetchDataed = async () => {
  //   try {
  //     const response = await axios.get(apiUrl + "/Branch");
  //     console.log("Response from server:", response.data);
  //     const branchName = localStorage.getItem("branch_name");
  //     const branchid = localStorage.getItem("branch_id");

  //     if (branchName === 'Branches') {
  //       setbranch(response.data); // If branchName is 'Branches', set all branches
  //     } else {
  //       const filteredData = response.data.filter(branch => branch._id === branchid);
  //       setbranch(filteredData); // If not, filter based on branch_id and set the filtered branches
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error.message);
  //   }
  // };



  const fetchData = async () => {
    try {
      setLoading(true);
      // Retrieve branch details and employee name from localStorage
      const branchId = localStorage.getItem("branch_id");
      const branchName = localStorage.getItem("branch_name");
      const empName = localStorage.getItem("username");

      // Check if the condition to fetch all data is met
      if (
        branchId === null ||
        branchName === "Branches" ||
        empName === undefined
      ) {
        // Fetch all attendance data if condition is true
        const response = await axios.get(apiUrl + "/travel_allowance");
        console.log(
          "Response from server with all attendance data:",
          response.data
        );
        setResponseData(response.data.reverse());
      } else {
        // Fetch data based on branchId and empid (from localStorage)
        const response = await axios.get(apiUrl + "/travel_allowance", {
          params: { data: branchId },
        });
        console.log(
          "Response from server with filtered attendance data:",
          response.data
        );

        // Get the empid from localStorage
        const localEmpid = localStorage.getItem("username");

        // Filter data based on the empid from localStorage
        const filteredData = response.data.filter(
          (item) => item.name === localEmpid
        );

        setResponseData(filteredData.reverse());
      }
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const gettoken = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(apiUrl + "/get_detail", {
        token: token,
      });
      console.log("token detail from server:", response.data);
      setroleid(response.data.detail.rolename);
      localStorage.setItem("role_id", response.data.detail.rolename);
      const id = response.data.detail.rolename;

      if (id) {
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const getprevillages = () => {
    const username = JSON.parse(localStorage.getItem("user_previllages"));
    console.log("tyhe username get by local stroage : ", username.modules);

    const total_previlages = username.modules;

    const new_enquiry = total_previlages.find(
      (item) => item.name == "Travel Allowance"
    );

    console.log("the new_enquiry is : ", new_enquiry.actions);

    setprevillages(new_enquiry.actions);
  };

  const handlesubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const formData = {
        branch_id: addData.branch_id,
        name: addData.name,
        Staff_name: addData.Staff_name,
        date: addData.date,
        allowance_type: allowance_type,
        transport_mode: addData.transport_mode,
        from: addData.from,
        to: addData.to,
        distance: addData.distance,
        ticket_bill: addData.ticket_bill,
        amount: addData.amount,
        status: "Applied",

        food_location: addData.food_location,
        food_bill: addData.food_bill,
        stay_location: addData.stay_location,
        stay_bill: addData.stay_bill,
        remarks: addData.remarks,
      };
      setAllowance_Type("");
      console.log("the form data ", formData);
      const response = await axios.post(apiUrl + "/travel_allowance", formData);
      console.log("Updated:", response);
      setShowModal(false);
      toast.success("added successfully!");
      setAddData({
        branch_id: "",
        name: "",
        Staff_name: "",
        date: "",
        allowance_type: "",
        transport_mode: "",
        from: "",
        to: "",
        distance: "",
        ticket_bill: "",
        amount: "",
        status: "",
        food_location: "",
        food_bill: "",
        stay_location: "",
        stay_bill: "",
        remarks: "",
      });
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const formatDatefitching = (isoDate) => {
    if (!isoDate) return ""; // Return an empty string if no date is provided
    const date = new Date(isoDate);

    const day = date.getDate().toString().padStart(2, "0"); // Add leading zero for single-digit days
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Add leading zero for single-digit months
    const year = date.getFullYear();

    return `${day}-${month}-${year}`; // Format as "day-month-year"
  };

  const handleDelete = async (id) => {
    try {
      setLoading(true);
      const response = await axios.delete(
        apiUrl + `/travel_allowance/${getdeleteid}`
      );
      console.log("delete data ", response);
      toast.error("Delete successfully!");
      setDeleteShowModals(false);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  // the pagination ---------------------------------------------------------------------
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = responseData.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const filtered = rows.filter((item) =>
    Object.values(item).some(
      (value) =>
        (typeof value === "string" &&
          value.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (typeof value === "number" && value.toString().includes(searchQuery))
    )
  );

  // const createPagination = () => {
  //   let liTag = [];

  //   // Previous Page Button
  //   liTag.push(
  //     <li
  //       className={`page-item ${!canPreviousPage ? "disabled" : ""}`}
  //       key="prev"
  //     >
  //       <button
  //         className="page-link"
  //         onClick={() => canPreviousPage && gotoPage(state.pageIndex - 1)}
  //         disabled={!canPreviousPage}
  //       >
  //         <FaAngleLeft /> Prev
  //       </button>
  //     </li>
  //   );

  //   // Page Numbers
  //   for (let plength = 1; plength <= pageCount; plength++) {
  //     liTag.push(
  //       <li
  //         key={plength}
  //         className={`page-item ${plength === state.pageIndex + 1 ? "active" : ""
  //           }`}
  //       >
  //         <button
  //           className="page-link"
  //           onClick={() => gotoPage(plength - 1)} // 0-indexed
  //         >
  //           {plength}
  //         </button>
  //       </li>
  //     );
  //   }

  //   // Next Page Button
  //   liTag.push(
  //     <li className={`page-item ${!canNextPage ? "disabled" : ""}`} key="next">
  //       <button
  //         className="page-link"
  //         onClick={() => canNextPage && gotoPage(state.pageIndex + 1)}
  //         disabled={!canNextPage}
  //       >
  //         Next <FaAngleRight />
  //       </button>
  //     </li>
  //   );

  //   return liTag;
  // };

  const createPagination = () => {
    let liTag = [];
    let totalPages = pageCount; // Total pages
    let currentPage = state.pageIndex;
    let active;

    // Previous Page Button
    liTag.push(
      <li
        className={`page-item ${!canPreviousPage ? "disabled" : ""}`}
        key="prev"
      >
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage - 1)}
          disabled={!canPreviousPage}
        >
          <FaAngleLeft /> Prev
        </button>
      </li>
    );

    // Always show first page
    if (totalPages > 1) {
      liTag.push(
        <li
          className={`page-item ${currentPage === 0 ? "active" : ""}`}
          key={0}
        >
          <button className="page-link" onClick={() => gotoPage(0)}>
            1
          </button>
        </li>
      );
    }

    // Show second page if total pages > 2
    if (totalPages > 2) {
      liTag.push(
        <li
          className={`page-item ${currentPage === 1 ? "active" : ""}`}
          key={1}
        >
          <button className="page-link" onClick={() => gotoPage(1)}>
            2
          </button>
        </li>
      );
    }

    // Add "..." before current page group
    if (currentPage > 3) {
      liTag.push(
        <li className="page-item disabled" key="dot-prev">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Show 3 pages around current page
    for (
      let i = Math.max(2, currentPage - 1);
      i <= Math.min(totalPages - 3, currentPage + 1);
      i++
    ) {
      active = currentPage === i ? "active" : "";
      liTag.push(
        <li className={`page-item ${active}`} key={i}>
          <button className="page-link" onClick={() => gotoPage(i)}>
            {i + 1}
          </button>
        </li>
      );
    }

    // Add "..." after current page group
    if (currentPage < totalPages - 4) {
      liTag.push(
        <li className="page-item disabled" key="dot-next">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Always show last two pages if totalPages > 2
    if (totalPages > 2) {
      liTag.push(
        <li
          className={`page-item ${currentPage === totalPages - 2 ? "active" : ""
            }`}
          key={totalPages - 2}
        >
          <button
            className="page-link"
            onClick={() => gotoPage(totalPages - 2)}
          >
            {totalPages - 1}
          </button>
        </li>
      );
    }

    if (totalPages > 1) {
      liTag.push(
        <li
          className={`page-item ${currentPage === totalPages - 1 ? "active" : ""
            }`}
          key={totalPages - 1}
        >
          <button
            className="page-link"
            onClick={() => gotoPage(totalPages - 1)}
          >
            {totalPages}
          </button>
        </li>
      );
    }

    // Next Page Button
    liTag.push(
      <li className={`page-item ${!canNextPage ? "disabled" : ""}`} key="next">
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage + 1)}
          disabled={!canNextPage}
        >
          Next <FaAngleRight />
        </button>
      </li>
    );

    return liTag;
  };

  // the pagination  end ---------------------------------------------------------------------

  const [allowance_type, setAllowance_Type] = useState("");

  const handleAllowanceChange = (event) => {
    setAllowance_Type(event.target.value);
    setAddData((prevData) => ({
      ...prevData,
      amount: "",
      transport_mode: "",
      from: "",
      to: "",
      remarks: "",
    }));
  };

  const handleAllowanceChanges = (event) => {
    const selectedAllowanceType = event.target.value;
    setUpdateData((prevData) => ({
      ...prevData,
      allowance_type: selectedAllowanceType,
      transport_mode: "",
      from: "",
      to: "",
      distance: "",
      amount: "",
      food_location: "",
      food_bill: "",
      remarks: "",
      ticket_bill: "",
    }));
  };

  const [idlocal, setlocalid] = useState([]);
  useEffect(() => {
    fetchData();
    const id_local = localStorage.getItem("username");
    setlocalid(id_local);
  }, []);

  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");

  const [deleteShowModals, setDeleteShowModals] = useState(false);
  const handleCloseModal = () => {
    setDeleteShowModals(false);
  };

  const [infoShowModal, setInfoShowModal] = useState(false);

  // const handleOpenInfo = async (_id) => {
  //   console.log(" the data to updata   onclick _id   ", _id);
  //   console.log(" the data to updata   onclick Update id   ", responseData);
  //   const allowance_response = await axios.get(
  //     apiUrl + `/travel_allowance/${_id}`
  //   );
  //   console.log("reponse is ok", allowance_response);
  //   setUpdateData(allowance_response.data);

  //   setInfoShowModal(true);
  // };

  const [responseStaff, setResponseStaff] = useState("");

  const [responseStaffss, setResponseStaffss] = useState("");

  const fetchStaff = async () => {
    try {
      const responsedstaff = await axios.get(apiUrl + `/staff`);
      console.log("Response staff datas :", responsedstaff.data);

      const storedUsername = localStorage.getItem("username");
      console.log("this 123", storedUsername);

      const datanew = responsedstaff.data.find((data) => {
        return data.empid === storedUsername;
      });

      console.log("this 123 is datanew", datanew);
      setResponseStaff(responsedstaff.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchStaff();
  }, []);

  const handleOpenInfo = async (_id, item) => {
    console.log(" the data to update onclick _id   ", _id);
    console.log(" the data to update onclick item   ", item);
    console.log(" the data to update onclick item   ", item.name);
    const dataname = item.name;
    console.log(" the data to update onclick responseStaff   ", responseStaff);
    // const selectedTravelMode = responseStaff.find(
    //   (item) => item.empid == item.name
    // );
    console.log(
      " the data to update onclick responseStaff 1233  ",
      responseStaffss
    );
    const selectedTravelMode = responseStaff.filter(
      (item) => item.empid == dataname
    );

    setResponseStaffss(selectedTravelMode);
    console.log(
      " the data to update onclick item selectedTravelMode  ",
      selectedTravelMode
    );

    const allowance_response = await axios.get(
      apiUrl + `/travel_allowance/${_id}`
    );
    console.log("response is ok", allowance_response);
    setUpdateData(allowance_response.data); // This should set the correct values for updateData
    setInfoShowModal(true);
  };

  const handleInfoClose = () => {
    setInfoShowModal(false);
  };

  const handleOpenModal = (_id, name) => {
    if (previllages.all || previllages.delete) {
      console.log(" the id", _id);
      console.log(" the name", name);
      setdeleteid(_id);
      setdeletename(name);
      setDeleteShowModals(true);
    } else {
      toast.error("You don't have the permission");
    }
  };

  useEffect(() => {
    // Set the current date in YYYY-MM-DD format
    const currentDate = new Date().toISOString().split("T")[0];
    setAddData((prevData) => ({
      ...prevData,
      date: currentDate, // Set the default date
    }));
  }, []);

  const [isUpdateshowModal, setUpdateShowModal] = useState(false);
  const [updateid, setUpdateId] = useState("");

  // const handleupdatesubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const formData = {
  //       name: idlocal,
  //       // mobile_no: updateData.mobile_no,
  //       from: updateData.from || "",
  //       to: updateData.to || "",
  //       travel_distance: updateData.travel_distance || "",
  //       date: updateData.date || "",
  //       allowance_type: updateData.allowance_type || "",
  //       transport_mode: updateData.transport_mode || "",
  //       distance: updateData.distance || "",
  //       ticket_bill: updateData.ticket_bill || "",
  //       amount: updateData.amount || "",
  //       status: updateData.status || "",
  //       food_location: updateData.food_location || "",
  //       food_bill: updateData.food_bill || "",
  //       stay_location: updateData.stay_location || "",
  //       stay_bill: updateData.stay_bill || "",
  //       remarks: updateData.remarks || "",
  //     };
  //     console.log("the update submit data", formData);
  //     const response = await axios.put(
  //       apiUrl + `/travel_allowance/${updateid}`,
  //       formData
  //     );
  //     console.log("response for update", response);
  //     setUpdateShowModal(false);
  //     toast.success("Update successfully!");
  //     fetchData();
  //   } catch (error) {
  //     console.error("Error updating data:", error.message);
  //   }
  // };

  const handleupdatesubmit = async (e) => {
    e.preventDefault();
    const formData = {
      branch_id: updateData.branch_id,
      name: updateData.name,
      mobile_no: updateData.mobile_no,
      from: updateData.from || "",
      to: updateData.to || "",
      travel_distance: updateData.travel_distance || "",
      date: updateData.date || "",
      allowance_type: updateData.allowance_type || "",
      transport_mode: updateData.transport_mode || "",
      distance: updateData.distance || "",
      ticket_bill: updateData.ticket_bill || "",
      amount: updateData.amount || "",
      status: updateData.status || "",
      food_location: updateData.food_location || "",
      food_bill: updateData.food_bill || "",
      stay_location: updateData.stay_location || "",
      stay_bill: updateData.stay_bill || "",
      remarks: updateData.remarks || "",
    };
    console.log("Submit Data: ", formData);
    try {
      setLoading(true);
      const response = await axios.put(
        apiUrl + `/travel_allowance/${updateid}`,
        formData
      );
      console.log("Response for update: ", response);
      setUpdateShowModal(false);
      toast.success("Update successful!");
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const handleUpdate = (_id, data) => {
    setUpdateId(_id);
    console.log(" the data to updata   onclick data   ", data);
    console.log(" the data to updata   onclick course id   ", data.course_id);

    console.log(
      " the data to updata   onclick course id   ",
      data.allowance_type
    );

    setUpdateShowModal(true);
    setUpdateData({
      branch_id: data.branch_id,
      name: data.name,
      mobile_no: data.mobile_no,
      from: data.from,
      to: data.to,
      travel_distance: data.travel_distance,
      date: data.date,
      allowance_type: data.allowance_type,
      transport_mode: data.transport_mode,
      distance: data.distance,
      ticket_bill: data.ticket_bill,
      amount: data.amount,
      status: data.status,
      food_location: data.food_location,
      food_bill: data.food_bill,
      stay_location: data.stay_location,
      stay_bill: data.stay_bill,
      remarks: data.remarks,
    });
  };

  const navigate = useNavigate();

  const [responsetype, setResponseType] = useState([]);

  const fetchDatased = async () => {
    try {
      const responsetypes = await axios.get(apiUrl + "/charge");
      setResponseType(responsetypes.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    fetchDatased();
  }, []);

  const getStatusLabelClass = (status) => {
    switch (status) {
      case "Applied":
        return "bg-primary1 text-white1 ";
      case "Verified":
        return "bg-warning1 text-white1 ";
      case "Approved":
        return "bg-success1 text-white1 ";
      default:
        return "";
    }
  };

  const handleDistanceChange = (e) => {
    const newDistance = e.target.value;
    yourFunctionToHandleDistance(newDistance);

    setAddData({ ...addData, distance: newDistance });
    setUpdateData({ ...updateData, distance: newDistance });
  };

  const yourFunctionToHandleDistance = (distance) => {
    console.log("Distance value changed to:", distance);

    const value = addData.per_km_charges * distance;
    console.log("multiple is ok", value);
    addData.amount = value;

    const updateDataValue = updateData.per_km_charges * distance;
    console.log("multiple is ok for updateData:", updateDataValue);
    updateData.amount = updateDataValue;
  };

  const getPerKmCharges = (selectedMode) => {
    const selectedTravelMode = responsetype.find(
      (item) => item.travel_mode === selectedMode
    );
    return selectedTravelMode ? selectedTravelMode.per_km_charges : "";
  };

  // const handleSelectChange = (e) => {
  //   const selectedMode = e.target.value;
  //   const perKmCharges = getPerKmCharges(selectedMode);

  //   addData.distance = "";
  //   addData.amount = "";

  //   setAddData({
  //     ...addData,
  //     transport_mode: selectedMode,
  //     per_km_charges: perKmCharges,
  //   });
  // };

  const handleSelectChange = (e) => {
    const selectedMode = e.target.value;
    const perKmCharges = getPerKmCharges(selectedMode);

    // Check if you are dealing with addData or updateData
    if (updateData.allowance_type === "Travel") {
      setUpdateData({
        ...updateData,
        transport_mode: selectedMode,
        per_km_charges: perKmCharges,
        from: "",
        to: "",
        distance: "",
        amount: "",
        remarks: "",
        ticket_bill: "",
      });
    } else {
      setAddData({
        ...addData,
        transport_mode: selectedMode,
        per_km_charges: perKmCharges,
      });
    }
  };

  // ===== code for set the value in sales dropdown =========
  const [isBranchselectDisabled, setIsBranchDisabled] = useState(false);
  const [isStaffselectDisabled, setIsStaffDisabled] = useState(false);

  // function handleAddClick() {

  //   const dropdown_branchcode = localStorage.getItem("branch_code");

  //   if(dropdown_branchcode != "All"){
  //     const dropdown_branch_id = localStorage.getItem("branch_id");

  //     // console.log("the dropdown_branch_id is : ",dropdown_branch_id);

  //     addData.branch_id = dropdown_branch_id;

  //     setIsBranchDisabled(true)
  //   }

  //   setShowModal(true)
  // }



  useEffect(() => {
    getdataforselectstaff();
    fetchDatastaff();
  }, [])


  const fetchDataed = async () => {
    try {
      const response = await axios.get(apiUrl + "/Branch");
      console.log("Response from server:", response.data);
      const branchName = localStorage.getItem("branch_name");
      const branchid = localStorage.getItem("branch_id");

      if (branchName === 'Branches') {
        setbranch(response.data);
        console.log("ewhrwjkre211111", branch)
        // If branchName is 'Branches', set all branches
      } else {
        const filteredData = response.data.filter(branch => branch._id === branchid);
        setbranch(filteredData);
        console.log("ewhrwjkre222", branch)


        console.log("the console filteredItems", branch[0]?.branch_id)
        console.log("the console filteredItems", staffId)
        const filteredDatas = staffId.filter((staff) =>
          staff.branch_id.some((branch) => branch.branch_id.branch_id === branch[0]?.branch_id)

        );
        setfilterdata(filteredDatas)
        console.log("the console`1`1", filteredDatas)
        console.log("the console", filteredItems)

      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };



  // const [filteredItems, setfilterdata] = useState([]);

  const handleBranch = (e) => {
    const selectedBranchId = e.target.value; // Selected branch ID
    setAddData({ ...addData, branch_id: selectedBranchId }); // Update state for branch_id
    setUpdateData({ ...updateData, branch_id: selectedBranchId }); // Update state for branch_id
    console.log("Selected Branch ID:", selectedBranchId);

    // Filter staff based on the selected branch
    const filteredData = staffId.filter((staff) =>
      staff.branch_id.some((branch) => branch._id === selectedBranchId)
    );
    setfilterdata(filteredData); // Update state with filte red staff
    console.log("Filtered Staff Data:", filteredData);

    console.log("Filtered staffId Data:", staffId);

  };


  const [filteredItems, setfilterdata] = useState([]);

  function handleAddClick() {
    // fetchDatastaff();
    getdataforselectstaff();

    console.log("the console filteredItems", branch[0]?.branch_id)
    console.log("the console filteredItems", staffId)
    // setShowModal(true);

    // code to set the dropdown
    const dropdown_branchcode = localStorage.getItem("branch_code");

    if (dropdown_branchcode != "All") {
      const dropdown_username = localStorage.getItem("username");
      const dropdown_name = localStorage.getItem("emp_name");
      const dropdown_branch_id = localStorage.getItem("branch_id");

      console.log("the dropdown_username is : ", dropdown_username)

      addData.branch_id = dropdown_branch_id;

      addData.name = dropdown_username;
      addData.Staff_name = dropdown_name;
      console.log("the addData.staff_id is : ", addData.name)
      console.log("the addData.staff_name is : ", addData.Staff_name)
      console.log("the filteredItems is : ", filteredItems)

      console.log("the staffId is : ", staffId);

      setIsBranchDisabled(true);
      setIsStaffDisabled(true);
    }

    setShowModal(true);
  }


  function getdataforselectstaff() {
    const dropdown_branch_id = localStorage.getItem("branch_id");

    const filteredData = staffId.filter((staff) =>
      // staff.branch_id.some((branch) => branch._id === selectedBranchId)
      staff.branch_id.some((branch) => branch._id === dropdown_branch_id)
    );

    console.log("the staffId is  : ", staffId);

    console.log("the filteredData in the getdataforselectstaff is : ", filteredData);

    setfilterdata(filteredData); // Update state with filtered staff
  }



  const handleEmpolye = (e) => {
    const selectedEmpId = e.target.value;
    const selectedEmpData = filteredItems.find((item) => item.empid === selectedEmpId);

    if (selectedEmpData) {
      setAddData({
        ...addData,
        name: selectedEmpData.empid,
        Staff_name: selectedEmpData.name, // Directly use staff name here
      });
    }
  };




  const fetchDatastaff = async () => {
    try {
      const response = await axios.get(apiUrl + "/staff");
      console.log("Response from server staff:", response.data);
      Setstaffid(response.data);

      console.log("the response.data in the fetchDatastaff is : ", response.data);

    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  fetchDataed();






  // ===== code for set the value in sales dropdown =========


  useEffect(() => {
    const branchName = localStorage.getItem("branch_name");
    setrolename(branchName);
  }, []);

  const [loading, setLoading] = useState(false);

  return (
    <>
      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />{" "}
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}

      <div className="top">
        <div className="" style={{ marginTop: "-80px" }}>
          <div className="row mb-3 justify-content-between">
            <div className="col-lg-8">
              <Link to="/dashboard" className="text-secondary dashBoard_text">
                <b>Dashboard / </b>
              </Link>

              <Link to="/dashboard" className="text-secondary dashBoard_text">
                <b>Staff / </b>
              </Link>

              <Link to="" className="text-danger dashBoard_text">
                <b>Allowance </b>
              </Link>
            </div>
            <div className="col-lg-4 d-flex justify-content-end">
              <div>
                <button
                  className="btn  btn-secondary"
                  onClick={() => navigate("/charge")}
                >
                  Allowance Charge
                </button>
              </div>
            </div>
          </div>
          {/* <div className="d-flex"> */}

          {/* </div> */}
        </div>

        {/* ------------ search and per page ----------------------------*/}

        <div className="mb-1 mt-3">
          <div className="row">
            <div className="col-lg-7 col-md-4 col-sm-1">
              <div className="d-flex">
                <h5 className="mt-1">Allowance</h5>
                {previllages.add && (
                  <button
                    className="btn  add mx-2"
                    // onClick={() => setShowModal(true)}
                    onClick={handleAddClick}
                  >
                    Add{" "}
                  </button>
                )}
              </div>
            </div>
            <div className="col-lg-5 col-md-4 col-sm-4 d-flex justify-content-end">

              {/* </div>
            
            <div className="col-lg-3 col-md-4 col-sm-7"> */}
              <div className="w-full flex-1 me-5">
                <form>
                  <div className="relative">
                    <input
                      className="form-control w-full bg-white appearance-none pl-8 dark:bg-gray-950"
                      placeholder="Search ..."
                      type="search"
                      value={state.globalFilter || ""} // Use the globalFilter value
                      onChange={(e) => setGlobalFilter(e.target.value)} // Update global filter
                    />
                  </div>
                </form>
              </div>
              <div className="d-flex me-2">
                <label className="form-label text-dark mt-1">Show : </label>
                <div>
                  <select
                    className="form-control w-100 mx-2"
                    value={state.pageSize}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === 'All') {
                        setPageSize(data.length);  // 'data' should be your dataset containing all the entries
                      } else {
                        setPageSize(Number(value));
                      }
                    }}
                  >
                    <option value="All">All</option> {/* Add 'All' option */}
                    {[10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    <div className="d-flex">
                      <div className="mx-2">{column.render("Header")}</div>
                      <div>
                        {column.canFilter ? column.render("Filter") : null}
                      </div>
                      <div className="mx-1">
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </div>
                    </div>
                  </Th>
                ))}
                <Th className="text-center">Action</Th>
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <Td {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                  ))}
                  <Td className="text-center">
                    <ActionsDropdown
                      row={row.original}
                      permissions={{
                        edit: previllages.edit,
                        delete: previllages.delete,
                      }}
                      onEdit={(id, row) =>
                        handleUpdate(id, row)
                      }
                      onDelete={(id, row) =>
                        handleOpenModal(id, row.name)
                      }
                      onInfo={(id, row) =>
                        handleOpenInfo(id, row)
                      }
                    />
                  </Td>
                </tr>
              );
            })}
          </tbody>
        </Table>

        {/* Modal for adding a new user */}
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title id="modeti">Add Allowance </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              <div className="floating-label">
                <select
                  className="form-select"
                  value={addData.branch_id}
                  onChange={handleBranch}
                  disabled={isBranchselectDisabled}
                >
                  <option value="">Select Branch</option>
                  {branch.map((item, index) => (
                    <option key={index} value={item._id}>
                      {item.branch_id} - {item.branch_name}
                    </option>
                  ))}
                </select>
                <label className={addData.branch_id ? "filled" : ""}>
                  Select Branch
                </label>
              </div>
              {/* <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={idlocal || ""}
                  onChange={(e) =>
                    setAddData({
                      ...idlocal,
                      name: e.target.value,
                    })
                  }
                  disabled
                  required
                />
                <label className={addData.idlocal ? "filled" : ""}>
                  Staff Name
                </label>
              </div> */}


              <div className="floating-label">
                <select
                  className="form-control"

                  value={addData.name}
                  onChange={(e) => handleEmpolye(e)}
                  required
                  disabled={isStaffselectDisabled}
                >
                  <option value="" disabled>Select Staff Id</option>
                  {filteredItems.map((item, index) => (
                    <option key={index} value={item.empid}>
                      {item.empid} - {item.name}
                    </option>
                  ))}
                </select>
                <label className={addData.name ? "filled" : ""}>
                  {/* Select Staff Id */}
                </label>
              </div>


              {/*     
              <div className="floating-label">
                <select
                  className="form-control"

                  value={addData.Staff_name}
                  onChange={(e) => handleEmpolye(e)}
                  required
                  disabled={isStaffselectDisabled}
                >
                  <option value="" disabled>Select Staff Name</option>
                  {filteredItems.map((item, index) => (
                    <option key={index} value={item.name}>
                      {item.empid} - {item.name}
                    </option>
                  ))}
                </select>
                <label className={addData.Staff_name ? "filled" : ""}>
                  Select Staff Name
                </label>
              </div>  */}


              <div className="floating-label">
                <input
                  className="form-control"
                  type="date"
                  placeholder=""
                  value={addData.date}
                  onChange={(e) =>
                    setAddData({ ...addData, date: e.target.value })
                  }
                  required
                />
                <label className={addData.date ? "filled" : ""}>
                  Visit Date
                </label>
              </div>

              <div className="floating-label">
                <select
                  className="form-control"
                  value={allowance_type}
                  onChange={handleAllowanceChange}
                >
                  <option value="" disabled>
                    Select Allowance Type
                  </option>
                  <option value="Travel">Travel</option>
                  <option value="Food">Food</option>
                  <option value="Stay">Stay or Accommodation</option>
                </select>
              </div>

              {allowance_type === "Travel" && (
                <>
                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={addData.transport_mode}
                      onChange={handleSelectChange}
                      required
                    >
                      <option value="">Select Travel Type</option>
                      {responsetype.map((item, index) => (
                        <option key={index} value={item.travel_mode}>
                          {item.travel_mode}
                        </option>
                      ))}
                    </select>
                    {addData.per_km_charges && (
                      <div>
                        {/* <p>Per Km Charges: {addData.per_km_charges}</p> */}
                      </div>
                    )}
                  </div>

                  {(addData.transport_mode === "Train" ||
                    addData.transport_mode === "Flight") && (
                      <div className="floating-label">
                        <input
                          className="form-control"
                          type="text"
                          placeholder=""
                          value={addData.ticket_bill}
                          onChange={(e) =>
                            setAddData({
                              ...addData,
                              ticket_bill: e.target.value,
                            })
                          }
                          required
                        />
                        <label className={addData.ticket_bill ? "filled" : ""}>
                          Tickets / Bill No
                        </label>
                      </div>
                    )}

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.from}
                      onChange={(e) =>
                        setAddData({ ...addData, from: e.target.value })
                      }
                      required
                    />
                    <label className={addData.from ? "filled" : ""}>From</label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.to}
                      onChange={(e) =>
                        setAddData({ ...addData, to: e.target.value })
                      }
                      required
                    />
                    <label className={addData.to ? "filled" : ""}>To</label>
                  </div>

                  {(addData.transport_mode === "Bike" ||
                    addData.transport_mode === "Car") && (
                      <div className="floating-label">
                        <input
                          className="form-control"
                          type="text"
                          placeholder=""
                          value={addData.distance}
                          onChange={handleDistanceChange}
                          required
                        />
                        <label className={addData.distance ? "filled" : ""}>
                          Distance (Kilometer)
                        </label>
                      </div>
                    )}

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.amount}
                      onChange={(e) =>
                        setAddData({ ...addData, amount: e.target.value })
                      }
                      required
                    />
                    <label className={addData.amount ? "filled" : ""}>
                      Amount
                    </label>
                  </div>
                </>
              )}

              {allowance_type === "Food" && (
                <>
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.food_location}
                      onChange={(e) =>
                        setAddData({
                          ...addData,
                          food_location: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={addData.food_location ? "filled" : ""}>
                      Location
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.food_bill}
                      onChange={(e) =>
                        setAddData({ ...addData, food_bill: e.target.value })
                      }
                      required
                    />
                    <label className={addData.food_bill ? "filled" : ""}>
                      Bill
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.amount}
                      onChange={(e) =>
                        setAddData({
                          ...addData,
                          amount: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={addData.amount ? "filled" : ""}>
                      Amount
                    </label>
                  </div>
                </>
              )}

              {allowance_type === "Stay" && (
                <>
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.stay_location}
                      onChange={(e) =>
                        setAddData({
                          ...addData,
                          stay_location: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={addData.stay_location ? "filled" : ""}>
                      Location
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.stay_bill}
                      onChange={(e) =>
                        setAddData({ ...addData, stay_bill: e.target.value })
                      }
                      required
                    />
                    <label className={addData.stay_bill ? "filled" : ""}>
                      Bill
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.amount}
                      onChange={(e) =>
                        setAddData({ ...addData, amount: e.target.value })
                      }
                      required
                    />
                    <label className={addData.food_location ? "filled" : ""}>
                      Amount
                    </label>
                  </div>
                </>
              )}
              <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={addData.remarks}
                  onChange={(e) =>
                    setAddData({ ...addData, remarks: e.target.value })
                  }
                  required
                />
                <label className={addData.remarks ? "filled" : ""}>
                  Remarks
                </label>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => {
                setShowModal(false);
                setAllowance_Type("");
              }}
            >
              Cancel
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handlesubmit}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>

        {/* update modal start */}

        <Modal
          show={isUpdateshowModal}
          onHide={() => setUpdateShowModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title id="modeti">Update Allowance</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">



              <div className="floating-label">
                <select
                  className="form-select"
                  value={updateData.branch_id?._id || ""} // Bind to _id of the selected branch
                  onChange={(e) => {
                    const selectedBranch = branch.find(
                      (item) => item._id === e.target.value
                    ); // Find the selected branch
                    setUpdateData({
                      ...updateData,
                      branch_id: selectedBranch || {}, // Update with the selected branch's object
                    });
                  }}
                  required
                >
                  <option value="">Branch</option>
                  {branch.map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.branch_name} {/* Display the branch name */}
                    </option>
                  ))}
                </select>
                <label className={updateData.branch_id?._id ? "filled" : ""}>
                  Branch
                </label>
              </div>

              {/* <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={idlocal}
                  onChange={(e) =>
                    setUpdateData({
                      ...idlocal,
                      name: e.target.value,
                    })
                  }
                  disabled
                  required
                />
                <label className={updateData.idlocal ? "filled" : ""}>
                  Staff Name
                </label>
              </div> */}


              <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={updateData.name}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      name: e.target.value,
                    })
                  }
                  required
                  disabled
                />

                <label className={updateData.name ? "filled" : ""}>Staff</label>
              </div>
              {/* <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={updateData.branch_id?.branch_name}
                    onChange={(e) =>
                      setAddData({ ...updateData, branch_id: e.target.value })
                    }
                    required
                  />
                  <label
                    className={updateData.branch_id?.branch_name ? "filled" : ""}
                  >
                    Branch
                  </label>
                </div> */}


              <div className="floating-label">
                <input
                  className="form-control"
                  type="date"
                  placeholder=""
                  value={updateData.date}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, date: e.target.value })
                  }
                  required
                  disabled
                />
                <label className={updateData.date ? "filled" : ""}>
                  Visit Date
                </label>
              </div>

              {/* <p>{allowance_type}</p> */}
              <div className="floating-label">
                <select
                  className="form-control"
                  value={updateData.allowance_type}
                  onChange={handleAllowanceChanges}
                >
                  <option value="" disabled>
                    Select Allowance Type
                  </option>
                  <option value="Travel">Travel</option>
                  <option value="Food">Food</option>
                  <option value="Stay">Stay or Accommodation</option>
                </select>
              </div>

              {updateData.allowance_type === "Travel" && (
                <>
                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={updateData.transport_mode}
                      onChange={handleSelectChange}
                      required
                    >
                      <option value="">Select Travel Type</option>
                      {responsetype.map((item, index) => (
                        <option key={index} value={item.travel_mode}>
                          {item.travel_mode}
                        </option>
                      ))}
                    </select>
                  </div>

                  {(updateData.transport_mode === "Train" ||
                    updateData.transport_mode === "Flight") && (
                      <div className="floating-label">
                        <input
                          className="form-control"
                          type="text"
                          placeholder=""
                          value={updateData.ticket_bill}
                          onChange={(e) =>
                            setUpdateData({
                              ...updateData,
                              ticket_bill: e.target.value,
                            })
                          }
                          required
                        />
                        <label className={updateData.ticket_bill ? "filled" : ""}>
                          Tickets / Bill No
                        </label>
                      </div>
                    )}

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.from}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, from: e.target.value })
                      }
                      required
                    />
                    <label className={updateData.from ? "filled" : ""}>
                      From
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.to}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, to: e.target.value })
                      }
                      required
                    />
                    <label className={updateData.to ? "filled" : ""}>To</label>
                  </div>

                  {/* {(updateData.transport_mode === "Bike" ||
                  updateData.transport_mode === "Car") && (
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.distance}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          distance: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.distance ? "filled" : ""}>
                      Distance (Kilometer)
                    </label>
                  </div>
                )} */}

                  {(updateData.transport_mode === "Bike" ||
                    updateData.transport_mode === "Car") && (
                      <div className="floating-label">
                        <input
                          className="form-control"
                          type="text"
                          placeholder=""
                          value={updateData.distance}
                          onChange={handleDistanceChange}
                          required
                        />
                        <label className={updateData.distance ? "filled" : ""}>
                          Distance (Kilometer)
                        </label>
                      </div>
                    )}

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.amount}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          amount: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.amount ? "filled" : ""}>
                      Amount
                    </label>
                  </div>
                </>
              )}

              {updateData.allowance_type === "Food" && (
                <>
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.food_location}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          food_location: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.food_location ? "filled" : ""}>
                      Location
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.food_bill}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          food_bill: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.food_bill ? "filled" : ""}>
                      Bill
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.amount}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          amount: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.amount ? "filled" : ""}>
                      Amount
                    </label>
                  </div>
                </>
              )}

              {updateData.allowance_type === "Stay" && (
                <>
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.stay_location}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          stay_location: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.stay_location ? "filled" : ""}>
                      Location
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.amount}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          amount: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.amount ? "filled" : ""}>
                      Bill
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.amount}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          amount: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.amount ? "filled" : ""}>
                      Amount
                    </label>
                  </div>
                </>
              )}

              <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={updateData.remarks}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, remarks: e.target.value })
                  }
                  required
                />
                <label className={updateData.remarks ? "filled" : ""}>
                  Remarks
                </label>
              </div>

              <div className="floating-label">
                <select
                  className="form-control"
                  value={updateData.status}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      status: e.target.value,
                    })
                  }
                  required
                >
                  <option value="">Choose Status</option>

                  <option value="Verified">Verified</option>
                  <option value="Approved">Approved</option>
                </select>
                <label className={updateData.status ? "filled" : ""}>
                  {updateData.status ? "Status" : ""}
                </label>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setUpdateShowModal(false)}
            >
              Cancel
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handleupdatesubmit}
            >
              Update
            </Button>
          </Modal.Footer>
        </Modal>

        {/* update modal end */}

        {/* _------------------------------pagination button -------------------------------- */}
        <div className="mt-3 pb-5">
          <div className="row">
            <div className="col-lg-7 col-sm-12 mt-1">
              <span className="text-dark">
                Page {state.pageIndex + 1} of {pageCount}
              </span>
            </div>
            <div className="col-lg-5">
              <div className="mt-3 pb-5">
                <nav>
                  <ul className="pagination justify-content-center">
                    {createPagination()} {/* Pagination buttons */}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>

        {/* ----------------delete */}

        <Modal
          className="modal"
          show={deleteShowModals}
          onHide={handleCloseModal}
        >
          <Modal.Header>
            <p id="modeti">Are you sure you want to Delete?</p>
          </Modal.Header>
          <Modal.Body>
            <label className="form-label d-flex">
              <h5 className="mx-1">Name :</h5> <h5>{getdeletename} </h5>
            </label>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={handleCloseModal}
            >
              Close
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handleDelete}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ---------------------------------------end ---------------------------------- */}

        <Modal className="modal" show={infoShowModal} onHide={handleInfoClose}>
          <Modal.Header>
            <p>Allowance Preview</p>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-5">
                <div className="card p-3 mb-4">
                  <img
                    className=""
                    alt=""
                    // src={`${apiUrl}/uploads/${responseStaff[0]?.photo_upload || ""}`}
                    src={`${apiUrl}/uploads/${responseStaffss[0]?.photo_upload ||
                      require("../../assets/img/photo.jfif")
                      }`}
                  ></img>
                </div>

                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={updateData.name}
                    disabled
                    required
                  />
                  <label className="">ID</label>
                </div>

                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={responseStaffss[0]?.name}
                    storedUsername
                    disabled
                    required
                  />
                  <label className="">Name</label>
                </div>

                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={responseStaffss[0]?.designation[0]?.designation}
                    disabled
                    required
                  />
                  <label className="">Designation</label>
                </div>

                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={updateData.allowance_type}
                    disabled
                    required
                  />
                  <label className="">Allowance Type</label>
                </div>
              </div>

              <div className="col-lg-7">
                {updateData.allowance_type === "Travel" ? (
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.transport_mode}
                      disabled
                      required
                    />
                    <label className="">Travel Type</label>
                  </div>
                ) : null}

                {(updateData.transport_mode === "Train" ||
                  updateData.transport_mode === "Flight") && (
                    <div className="floating-label">
                      <input
                        className="form-control"
                        type="text"
                        placeholder=""
                        value={updateData.ticket_bill}
                        disabled
                        required
                      />
                      <label className="">Tickets / Bill No</label>
                    </div>
                  )}

                {updateData.allowance_type === "Travel" ? (
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.from}
                      disabled
                      required
                    />
                    <label className="">From</label>
                  </div>
                ) : null}

                {updateData.allowance_type === "Travel" ? (
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.to}
                      disabled
                      required
                    />
                    <label className="">To</label>
                  </div>
                ) : null}

                {(updateData.transport_mode === "Bike" ||
                  updateData.transport_mode === "Car") && (
                    <div className="floating-label">
                      <input
                        className="form-control"
                        type="text"
                        placeholder=""
                        value={updateData.distance}
                        disabled
                        required
                      />
                      <label className="">Distance</label>
                    </div>
                  )}

                {/* {(updateData.allowance_type === "Food" ||
                  updateData.allowance_type === "Stay") && (
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.food_location}
                      disabled
                      required
                    />
                    <label className="">Location</label>
                  </div>
                )} */}

                {(updateData.allowance_type === "Food" ||
                  updateData.allowance_type === "Stay") && (
                    <div className="floating-label">
                      <input
                        className="form-control"
                        type="text"
                        placeholder=""
                        value={
                          updateData.food_location ||
                          updateData.stay_location ||
                          ""
                        }
                        disabled
                        required
                      />
                      <label className="">Location</label>
                    </div>
                  )}

                {(updateData.allowance_type === "Food" ||
                  updateData.allowance_type === "Stay") && (
                    <div className="floating-label">
                      <input
                        className="form-control"
                        type="text"
                        placeholder=""
                        // value={updateData.food_bill}
                        value={
                          updateData.food_bill ||
                          updateData.stay_bill ||
                          ""
                        }
                        disabled
                        required
                      />
                      <label className="">Bill</label>
                    </div>
                  )}

                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={updateData.amount}
                    disabled
                    required
                  />
                  <label className="">Amount</label>
                </div>

                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={updateData.remarks}
                    disabled
                    required
                  />
                  <label className="">Remarks</label>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={handleInfoClose}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

export default Travel_Allowance;
